import React from "react";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import pages from "../../../scripts/myga-ui";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Button,Container,Row} from "react-bootstrap";
import {PAGES} from "../../../scripts/constants";
import Resources from "../../../Resources/Resources";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {NassauLog} from "../../../scripts/myga-utils"
import GENERATOR from "../../../selenium-front-end/generator/Generator";

class AppPartialCompleteAgentRecommendation extends React.Component {
    
    constructor(props) {
        super(props);
        // setup default prev/next pages with props overrides
        // this.nextPage = props.nextPage || PAGES.pageDashboard; // 2021.07.15.ADivelbiss - commented in favor of PageManager getNextPage solution
        NassauLog("AppPartialCompleteAgentRecommendation");
    }
    
    onNextPressed = async () => {
        if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
            // if the test mode is running then stop the test at this point.
            await GENERATOR.disableAfterNextCommit();
        }
    };
    
    render() {

        return (
    
            <AppContentWrapper
                nextLabel={MYGAStrings.AppPartialCompletedAR_ButtonForwardLabel}
                onNextPressed={this.onNextPressed}
                updatePage={this.props.updatePage}>
        
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div id={pages.app_completed.html.text_completed_message}
                             className={"font-page-regular"}>
                            <p>{MYGAStrings.AppPartialCompletedAR_CompletedMessage}</p>
                            <p>{MYGAStrings.AppPartialCompletedAR_CompletedMessageP2}</p>
                        </div>
                    </div>
                </div>
        
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div className={"col-2 app-completed-icons"}>
                            <FontAwesomeIcon icon={Resources.Icons.EnvelopeOpenText}/>
                        </div>
                        <div className={"col-10"}>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_receive_email_label}
                                     className={"page-section-title"}>
                                    {MYGAStrings.AppPartialCompletedAR_ReceiveEmailAndSignLabel}
                                </div>
                            </div>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_receive_email_message}
                                     className={"font-page-regular"}>
                                    {MYGAStrings.AppPartialCompletedAR_ReceiveEmailAndSign}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div className={"col-2 app-completed-icons"}>
                            <FontAwesomeIcon icon={Resources.Icons.Search}/>
                        </div>
                        <div className={"col-10"}>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_review_application_label}
                                     className={"page-section-title"}>
                                    {MYGAStrings.AppPartialCompletedAR_ReviewApplicationLabel}
                                </div>
                            </div>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_review_application_message}
                                     className={"font-page-regular"}>
                                    {MYGAStrings.AppPartialCompletedAR_ReviewApplication}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div className={"col-2 app-completed-icons"}>
                            <FontAwesomeIcon icon={Resources.Icons.DollarSign}/>
                        </div>
                        <div className={"col-10"}>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_making_payment_label}
                                     className={"page-section-title"}>
                                    {MYGAStrings.AppPartialCompletedAR_MakingPaymentLabel}
                                </div>
                            </div>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_making_payment_message}
                                     className={"font-page-regular"}>
                                    {MYGAStrings.AppPartialCompletedAR_MakingPayment}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div className={"col-2 app-completed-icons"}>
                            <FontAwesomeIcon icon={Resources.Icons.FileContract}/>
                        </div>
                        <div className={"col-10"}>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_have_contract_label}
                                     className={"page-section-title"}>
                                    {MYGAStrings.AppPartialCompletedAR_HaveContractInHandLabel}
                                </div>
                            </div>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_have_contract_message}
                                     className={"font-page-regular"}>
                                    {MYGAStrings.AppPartialCompletedAR_HaveContractInHand}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div id={pages.app_completed.html.text_fine_print}
                             className={"page-fine-print"}>
                            {MYGAStrings.AppPartialCompletedAR_FinePrint}
                        </div>
                    </div>
                </div>
    
            </AppContentWrapper>
            
        );

    }
}

export default AppPartialCompleteAgentRecommendation;